// extracted by css-extract-rspack-plugin
export default {"cls1":"ResearchExamples-cls1_mK7","cls2":"ResearchExamples-cls2_o3t ResearchExamples-cls1_mK7"};